import authService from "@/services/auth/auth.service";
const otherCostsRoutes = [
  {
    path: "/payments/otherCosts",
    name: "OtherCostsNewForm",
    component: () => import("@/components/areas/payments/otherCosts/OtherCostsNewForm.vue"),
    props: (route) => {
      return {
        openDialog: true,
        pathToGoBack: route.query.pathToGoBack,
        tabName: route.query.tabName || 'general'
      }
    },
    beforeEnter: (to, from, next) => {
      authService.redirectIfLicenseBlocked()
      next()
    }
  },
  {
    path: "/payments/otherCosts/:id/edit",
    name: "OtherCostsEditForm",
    component: () => import("@/components/areas/payments/otherCosts/OtherCostsEditForm.vue"),
    props: (route) => {
      return {
        openDialog: true,
        pathToGoBack: route.query.pathToGoBack,
        pathName: route.query.pathName,
        tabName: route.query.tabName || 'general',
        filters: route.params.filters
      }
    },
  },
  {
    path: "/payments/otherCosts/list",
    name: "OtherCostsList",
    component: () =>
      import(
        "@/components/areas/payments/otherCosts/OtherCostsList.vue"
      ),
    props: (route) => {
      return {
        filters: route.params.filters,
      }
    }
  },
]

export default otherCostsRoutes;
